import type { CommonPublishCoupon } from '@bucketplace/common';
import { camelizeKeys } from 'humps';
import { clientHttp } from '@/common/http';
import type {
  RaffleEntryResponse,
  RepresentativeRaffleEvent,
} from '@/promotions/types';

export const publishProductCouponMolds = async ({
  id,
  userId,
}: {
  id: number;
  userId: string;
}): Promise<CommonPublishCoupon> => {
  const json = await clientHttp
    .post('/api/promotions/product-coupon/create', {
      json: {
        couponMoldId: id,
        userId,
      },
    })
    .json<CommonPublishCoupon>();
  return camelizeKeys(json) as CommonPublishCoupon;
};

export const getRaffleEvent = async (
  groupId: string,
): Promise<RepresentativeRaffleEvent> => {
  const json = await clientHttp
    .get(`/api/promotions/raffle/${groupId}`)
    .json<RepresentativeRaffleEvent>();
  return camelizeKeys(json) as RepresentativeRaffleEvent;
};

export const postRaffleEntry = async (
  eventId: string,
  exhibitionId: string,
): Promise<RaffleEntryResponse> => {
  const res = await clientHttp
    .post('/api/promotions/raffle/entry', {
      json: {
        eventId,
        campaignId: exhibitionId,
      },
    })
    .json<RaffleEntryResponse>();

  return res as RaffleEntryResponse;
};
